import { hash } from "@ember/helper";
import Combobox from "discourse/select-kit/components/combo-box";
import SearchFieldBase from "./base";
import SearchFieldWireFrame from "./wire-frame";

export default class SearchFieldDropdown extends SearchFieldBase {
  get noneLabel() {
    return this.placeholder;
  }

  get content() {
    return this.args.filter.options;
  }

  <template>
    <SearchFieldWireFrame
      ...attributes
      @controller={{@controller}}
      @filter={{@filter}}
      @value={{@value}}
    >
      <Combobox
        name={{@filter.name}}
        @nameProperty={{@nameProperty}}
        @valueProperty={{@valueProperty}}
        @value={{@value}}
        @none="test"
        @content={{this.content}}
        @options={{hash translatedNone=this.noneLabel}}
      />
    </SearchFieldWireFrame>
  </template>
}
